module.exports = __webpack_public_path__ + "static/media/about-us-feature-5.4774f7ae.jpg";